import { render, staticRenderFns } from "./ProductsViewFooter.vue?vue&type=template&id=a25f5e04&scoped=true"
import script from "./ProductsViewFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductsViewFooter.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductsViewFooter.vue?vue&type=style&index=0&id=a25f5e04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25f5e04",
  null
  
)

export default component.exports